import { useUserProfile } from "@src/components/user/user-context";
import { useEffect, useRef } from "react";
import { useDesktopProfiles } from "./use-desktop-profiles";

/**
 * Automatically synchronizes the active window's user metadata
 * (email, avatar, and presence color) with the active desktop profile.
 */
export function useDesktopProfileSync() {
	const {
		user: [user],
		color: [currentColor],
	} = useUserProfile();

	const { isElectron, currentProfileId, updateProfile, loading } =
		useDesktopProfiles();

	const lastSyncRef = useRef<string>("");

	useEffect(() => {
		if (!isElectron || loading || !currentProfileId || !user) return;

		const email = user.email || undefined;
		const avatarUrl = user.avatarUrl || undefined;
		const color = currentColor || user.presenceColor || undefined;

		const syncKey = `${currentProfileId}:${email}:${avatarUrl}:${color}`;
		if (lastSyncRef.current === syncKey) return;
		lastSyncRef.current = syncKey;

		void updateProfile(currentProfileId, {
			email,
			avatarUrl,
			color,
		});
	}, [
		isElectron,
		loading,
		currentProfileId,
		user,
		user?.email,
		user?.avatarUrl,
		currentColor,
		user?.presenceColor,
		updateProfile,
	]);
}
